import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { heroSlides, type HeroSlide } from "@/mocks/site";
import { newsList, type NewsItem } from "@/mocks/news";
import { worksList } from "@/mocks/works";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewsHighlight from "@/pages/home/components/NewsHighlight";
import WorkShowcase from "@/pages/home/components/WorkShowcase";
import SiteIntro from "@/pages/home/components/SiteIntro";
import NewsModal from "@/components/feature/NewsModal";

export default function Home() {
  const navigate = useNavigate();
  const [activeNews, setActiveNews] = useState<NewsItem | null>(null);

  useSeo({
    title: "佐佐木明希 - 明星资讯与最新影视作品介绍",
    description:
      "佐佐木明希官网，提供最新的明星资讯、影视作品动态及演艺资料，涵盖电视剧、电影等内容，满足粉丝了解和追踪的需求。",
    keywords: "佐佐木明希,明星资讯,影视作品,演艺资料,电视剧介绍,电影动态,娱乐新闻",
  });

  const latestNews = useMemo(
    () => [...newsList].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 6),
    []
  );

  const featuredWorks = useMemo(
    () =>
      [...worksList]
        .sort((a, b) => b.year - a.year || b.popularity - a.popularity)
        .slice(0, 8),
    []
  );

  const handleSlideSelect = (slide: HeroSlide) => {
    if (slide.linkType === "work") {
      navigate(`/works/${slide.linkId}`);
      return;
    }
    const news = newsList.find((n) => n.id === slide.linkId);
    if (news) setActiveNews(news);
  };

  return (
    <>
      <HeroCarousel slides={heroSlides} onSelect={handleSlideSelect} />
      <NewsHighlight items={latestNews} onOpen={setActiveNews} />
      <WorkShowcase items={featuredWorks} />
      <SiteIntro />
      <NewsModal item={activeNews} onClose={() => setActiveNews(null)} />
    </>
  );
}